<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>directions_car</v-icon> Controles de autos:
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                    />
                    <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date"
                            label="Fecha inicio"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                        />
                      </template>

                      <v-date-picker v-model="date" scrollable locale="es-co">
                        <v-spacer/>
                        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                      </v-date-picker>

                    </v-dialog>

                    <v-dialog
                        ref="dialogfin"
                        v-model="modal_date_end"
                        :return-value.sync="date_end"
                        persistent
                        width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date_end"
                            label="Fecha final"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                        />
                      </template>
                      <v-date-picker v-model="date_end" scrollable locale="es-co">
                        <v-spacer/>
                        <v-btn text color="primary" @click="modal_date_end = false">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.dialogfin.save(date_end)">OK</v-btn>
                      </v-date-picker>

                    </v-dialog>

                  <div v-if="controlsAutos.length > 0">
                    <download-excel
                        class="v-btn v-btn--contained theme--light v-size--default success mx-2"
                        :data="controlsAutos"
                        :fields="json_fields"
                        worksheet="Controles-autos"
                        :name="`controles_autos_${$moment().format()}.xls`"

                    >
                      Exportar excel
                    </download-excel>
                    <v-btn @click="resetControls()" v-if="date.length > 0 && date_end.length > 0" color="warning">reiniciar</v-btn>
                  </div>

                   <div v-else>
                     <v-btn @click="getControls()" v-if="date.length > 0 && date_end.length > 0" color="primary">Consultar</v-btn>
                   </div>

                  </v-card-title>
                  <v-data-table
                          :headers="headers"
                          :items="controlesAutos"
                          :items-per-page="5"
                          :search="search"
                          class="elevation-1"
                          ref="table"
                  >
                      <template v-slot:item.auto="{ item }">
                          {{item.auto.fabricante + ' ' + item.auto.modelo + ' ' + item.auto.color}}
                      </template>

                      <template v-slot:item.user="{ item }">
                          {{item.user.first_name + ' ' +item. user.last_name}}
                      </template>

                      <template v-slot:item.type="{ item }">
                          {{item.user.role}}
                      </template>
                      <template v-slot:item.approved="{ item }">
                          {{item.approved ? 'Si' : 'No'}}
                      </template>
                      <template v-slot:item.createdAt="{ item }">
                          {{item.createdAt.toDate() | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                      </template>
                  </v-data-table>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import {mapState} from "vuex";

    import {db} from "@/plugins/db";

    export default {
        name: "ControlAuto",
        data(){
            return{
                controlsAutos:[],
                modal:false,
                modal_date_end:false,
                date:'',
                date_end:'',
                headers: [
                    {
                        text: 'Usuario',
                        align: 'left',
                        sortable: true,
                        value: 'user',
                    },
                    { text: 'Tipo', value: 'type' },
                    { text: 'Conductor', value: 'driver' },
                    { text: 'Auto', value: 'auto' },
                    { text: '¿Aprobado?', value: 'approved' },
                    { text: 'Creado', value: 'createdAt' },

                ],
                search:'',
                json_fields: {
                  "Nombre empleado": {
                    field: "user",
                    callback: (value) => {
                      return `${value.first_name} ${value.last_name}`;
                    },
                  },
                  "Rol del empleado": "user.role",
                  "Tipo de empleado": "user.type",
                  "Nombre de conductor": "auto.name",
                  Color: "auto.color",
                  Matricula: "auto.matricula",
                  Modelo: "auto.color",
                  Fabricante: "auto.fabricante",
                  Condominio: "auto.condominio",
                  Apartamento: "auto.apartamento",
                  "Fecha": {
                    field: "createdAt",
                    callback: (value) => {
                      return `${this.$moment(value.toDate()).format()}`;
                    },
                  },
                  "Aprobado": {
                    field: "approved",
                    callback: (value) => {
                      return value ? 'si': 'no';
                    },
                  },



                },
            }
        },
        methods:{
          resetControls(){
            this.controlsAutos = [];
          },

          async getControls(){
            let date  = this.$moment(this.date).format();
            let newDate = new  Date(date);
            let endDate = this.date_end.length === 0 ? new Date(this.$moment(this.date).add(1, 'days')) : new Date(this.$moment(this.date_end).add(1, 'days'));
            this.controlsAutos = [];
            const control = await db.collection('ControlesAutos')
                .orderBy('createdAt', 'desc')
                .where('createdAt', ">", newDate)
                .where('createdAt', '<',endDate )
                .get();
            if (control){
              control.forEach(e => {
                this.controlsAutos.push(e.data())
              })
            }
          }

        },
        computed:{
            ...mapState({
                controlesAutos:state =>state.auto.controlesAutos
            }),
        }
    }
</script>

<style scoped>

</style>
